// extracted by mini-css-extract-plugin
export default {"root":"NoData_root__3V0cD","textWrapper":"NoData_textWrapper__n9Eni","sub-title":"NoData_sub-title__6eaH9"};